import { Component } from '@grafikr/components';

import clear from 'utils/clear';
import { NonNullish } from 'utils/nullish-check';
import { lock, unlock } from 'utils/scroll-lock';

export default Component((node) => {
  const megamenu = node.querySelector<HTMLElement>('[data-megamenu]');

  const init = () => {
    if (!megamenu) {
      return;
    }

    const inner = NonNullish(megamenu.querySelector<HTMLElement>('[data-megamenu-inner]'));
    const megamenuContents = megamenu.querySelector<HTMLElement>('[data-menu-contents]');
    const megamenuTriggers = Array.from(node.querySelectorAll<HTMLElement>('[aria-controls]'));

    if (!megamenuContents) {
      return;
    }

    const reset = () => {
      if (megamenu.classList.contains('is-active')) {
        unlock();
      }

      megamenuTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      megamenu.classList.remove('is-active');
      document.documentElement.classList.remove('megamenu-open');
    };

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse') {
        return;
      }

      if (
        !inner.contains(event.target as Node) &&
        !megamenuTriggers.some((trigger) => trigger.contains(event.target as Node))
      ) {
        reset();
      }
    });

    megamenuTriggers.forEach((trigger) => {
      const match = node.querySelector<HTMLTemplateElement>(
        `#${trigger.getAttribute('aria-controls')}`,
      );

      trigger.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') {
          return;
        }

        reset();

        if (!match) {
          return;
        }

        lock();
        document.documentElement.style.setProperty(
          '--scrolled',
          `${document.documentElement.scrollTop}px`,
        );
        document.documentElement.classList.add('megamenu-open');
        trigger.setAttribute('aria-expanded', 'true');
        megamenu.classList.add('is-active');
        megamenuContents.classList.add('is-loading');

        setTimeout(() => {
          clear(megamenuContents);
          megamenuContents.appendChild(match.content.cloneNode(true));
          megamenuContents.classList.remove('is-loading');
        }, 200);
      });
    });
  };

  init();
});
